import { render } from "./AvatarPreview.vue?vue&type=template&id=7c5b015a&ts=true"
import script from "./AvatarPreview.vue?vue&type=script&lang=ts"
export * from "./AvatarPreview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__